import React, {Fragment} from 'react';
import PageTitle from '../../components/pagetitle/PageTitle';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/footer/Footer'
import Scrollbar from '../../components/scrollbar/scrollbar'
import SEO from '../../components/SEO/SEO';
import { seoData } from '../../utils/seoData';
import Contactpage from '../../components/Contactpage/Contactpage';


const ContactPage =() => {
    return(
        <Fragment>
            <SEO 
                title={seoData.contact.title}
                description={seoData.contact.description}
                keywords={seoData.contact.keywords}
            />
            <Navbar/>
            <PageTitle pageTitle={'Contact Us'} pagesub={'Contact'} customClass={'contact-page-banner'}/> 
            <Contactpage/> 
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};

export default ContactPage;

